import React from 'react';

import { useProfessionalSignUp } from 'src/modules/app/hooks/useProfessionalSignUp';

import { PartialProfileForm } from './PartialProfileForm';
import { ProfileForm } from './ProfileForm';

const OrganizationForm = () => {
  const { user } = useProfessionalSignUp();

  if ('needsUserUpdate' in user) {
    return <PartialProfileForm />;
  }

  return <ProfileForm />;
};

export { OrganizationForm };
